import { render, staticRenderFns } from "./EventsCarousel.vue?vue&type=template&id=68e0635c&scoped=true&"
import script from "./EventsCarousel.vue?vue&type=script&lang=js&"
export * from "./EventsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./EventsCarousel.vue?vue&type=style&index=0&id=68e0635c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0635c",
  null
  
)

export default component.exports